import { colours, type Surface, type Tokens } from './tokens';
import { useTheme } from './theme';

/** Raw colour values for the current theme (for the map, which can't read CSS variables). */
export function useColours(surface: Surface = 'map'): Tokens {
  const { mode } = useTheme();
  return colours(mode, surface);
}
